import { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Public gallery of APPROVED client photos/videos. Renders nothing when empty.
export default function ClientPhotosGallery() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { api.get("/client-photos").then((r) => setItems(r.data || [])).catch(() => setItems([])); }, []);
  if (items.length === 0) return null;

  const credit = (m) => m.credit_name || t("reviews.clientPhotosFamily");

  return (
    <section className="mt-12" data-testid="client-photos-gallery">
      <h2 className="text-2xl font-normal text-charcoal-800 mb-5">{t("reviews.clientPhotosTitle")}</h2>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((m) => (
          <figure key={m.id} className="space-y-1.5">
            {m.kind === "video" ? (
              <video data-testid={`client-photo-${m.id}`} src={`${BACKEND}${m.url}`} controls muted playsInline preload="none" className="h-56 w-full rounded-2xl border border-sand-300 object-cover bg-black" />
            ) : (
              <button type="button" onClick={() => setActive(m)} data-testid={`client-photo-${m.id}`} className="block w-full overflow-hidden rounded-2xl border border-sand-300 focus:outline-none focus:ring-2 focus:ring-terracotta">
                <img src={`${BACKEND}${m.url}`} alt={m.caption || credit(m)} loading="lazy" className="h-56 w-full object-cover transition-transform duration-300 hover:scale-[1.02]" />
              </button>
            )}
            <figcaption className="text-xs text-charcoal-500">
              {m.caption && <span className="text-charcoal-600">{m.caption} · </span>}{credit(m)}
            </figcaption>
          </figure>
        ))}
      </div>

      {active && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 p-4" onClick={() => setActive(null)} data-testid="client-photo-lightbox">
          <button className="absolute top-4 right-4 text-white/90" aria-label="Close"><X size={28} /></button>
          <figure className="max-h-[90vh] max-w-4xl" onClick={(e) => e.stopPropagation()}>
            <img src={`${BACKEND}${active.url}`} alt={active.caption || credit(active)} className="max-h-[80vh] w-auto rounded-xl object-contain" />
            <figcaption className="mt-2 text-center text-sm text-white/80">{active.caption && `${active.caption} · `}{credit(active)}</figcaption>
          </figure>
        </div>
      )}
    </section>
  );
}
